import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactElement } from 'react';

interface IProps {
  variation?: string;
}

export const AnnotationTopBarItem = observer(
  (props: PropsWithChildren<IProps>): ReactElement => <div className={classNames('element', props.variation)}>{props.children}</div>
);
